import React, { useState, useEffect } from 'react';
import { Table, TableProps, FormField, DatePicker, Badge, Button, Grid, TextContent, Input, Link } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatDate } from '../../../commons/functions'; // Import the function //storeJWT, storeJWT2
import { enumOperators, stringOperators } from '../../../../common/property-filter-operators';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import DatePickerModal from '../../../../components/DatePickerModal';
import { subMonths, format } from 'date-fns';
import Icon from '@mdi/react';
import { mdiBoomGateArrowUpOutline, mdiCalendarOutline, mdiCheckCircleOutline, mdiCloseCircleOutline, mdiDeleteClockOutline, mdiEmailOpenOutline, mdiHelpCircleOutline, mdiLockOpenOutline, mdiLockOutline, mdiRefresh, mdiTimerEditOutline, mdiTimerPlusOutline, mdiTimerSandEmpty } from '@mdi/js';

const pageSize = 20;

const getTodayFormatted = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, '0'); // Months are 0-based
    const day = `${today.getDate()}`.padStart(2, '0');
    return `${year}/${month}/${day}`;
};
export const LogsAllPage = () => {

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');

    const storeAdmin = useStoreAdmin();
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const [sortingColumn, setSortingColumn] = useState({
        sortingField: 'displayName',
        isDescending: false,
    });
    const [date, setDate] = useState(getTodayFormatted); // Manage HelpPanel state

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const { loading, setLoading } = useGlobalState();
    const [logs, setLogs] = useState<LogItem[]>([]);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filteringText, setFilteringText] = useState('');
    const filteredLogs = logs.filter(logs => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            logs.log.toLowerCase().includes(word) ||
            logs.status.toLowerCase().includes(word) ||
            logs.hora.toLowerCase().includes(word) ||
            logs.fecha.toLowerCase().includes(word)
        );
    });

    type LogItem = {
        idLog: number;
        fecha: string;
        hora: string;
        status: string;
        log: string;
        user: string;
        objTime: string;
    };

    type SortableFields = keyof LogItem;

    const field = sortingColumn.sortingField as SortableFields;

    const sortedLogs = [...filteredLogs].sort((a, b) => {
        const aValue = a[field]?.toString().toLowerCase() ?? "";
        const bValue = b[field]?.toString().toLowerCase() ?? "";

        if (aValue < bValue) return sortingColumn.isDescending ? 1 : -1;
        if (aValue > bValue) return sortingColumn.isDescending ? -1 : 1;
        return 0;
    });

    const paginatedLogs = sortedLogs.slice(
        (currentPageIndex - 1) * pageSize,
        currentPageIndex * pageSize
    );


    // Handle row click to fetch additional data and open the HelpPanel
    const handleYesterday = async () => {
        let today = new Date();
        today.setDate(today.getDate() - 1);

        const normalizedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const formatted = normalizedStart.toISOString().slice(0, 10);
        setSelectedDate(formatted)
    }
    const handleToday = async () => {
        let today = new Date();
        const normalizedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const formatted = normalizedStart.toISOString().slice(0, 10);
        setSelectedDate(formatted)
    }
    const handleRefresh = async () => {
        if (selectedDate !== "") {
            try {
                setLoading(true);
                const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/admin/logs/list',
                        'JWT': JWT,

                    },
                    body: JSON.stringify({
                        orderBy: "fecha",
                        order: "desc",
                        fecha: formatDate(selectedDate),
                        fecha2: selectedDate,

                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                storeAdmin(data);
                if (data && data.logs) setLogs(data.logs)
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        //console.log("useEffect:Date " + date)
        handleRefresh();
    }, [date]);


    useEffect(() => {
        //console.log("useEffect:Date " + date)
        handleRefresh();
    }, [selectedDate]);
    type SortingColumn = {
        sortingField: keyof LogItem;  // This should map to the keys of UserUnit
        isDescending: boolean;
    };
    type SortingChangeHandler = TableProps<LogItem>['onSortingChange'];

    const handleSortingChange: SortingChangeHandler = (event) => {
        const { sortingColumn: eventSortingColumn, isDescending: eventIsDescending } = event.detail;

        setSortingColumn((prevSortingColumn) => ({
            sortingField: eventSortingColumn?.sortingField || 'idLog',
            isDescending:
                prevSortingColumn.sortingField === eventSortingColumn?.sortingField
                    ? !prevSortingColumn.isDescending
                    : false, // Default to ascending when a new column is clicked
        }));
        // your logic
    };

    return (

        <CustomAppLayout
            //title={propiedad}
            //            toolsOpen={drawerOpen}
            toolsHide={true}
            contentType="form"
            breadcrumbs={<BreadcrumbGroup
                items={[
                    { text: 'Inicio', href: '#home' },
                    { text: 'Reportes', href: '#logs' },
                    { text: 'Bitácura', href: '#create-transcription-job' },
                ]}
                expandAriaLabel="Show path"
                ariaLabel="Breadcrumbs" />}
            content={
                <SpaceBetween direction='vertical' size='xs'>
                    <Table
                        stripedRows
                        wrapLines
                        stickyHeader
                        sortingColumn={sortingColumn} // Pass sortingColumn directly
                        sortingDescending={sortingColumn.isDescending} // Pass isDescending directly from state
                        onSortingChange={handleSortingChange} // Pass onSortingChange directly
                        renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) => `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`}
                        //onSelectionChange={handleSelectionChange}
                        columnDefinitions={[
                            {
                                id: "idLog",
                                header: "Hora",
                                cell: (item) => item.hora,
                                width: 110,
                            }, {
                                id: "status",
                                header: "Categoría",
                                cell: (item) => {
                                    let statusText = '';
                                    let statusColor: "red" | "blue" | "grey" | "green" | "yellow" | "severity-critical" | "severity-high" | "severity-medium" | "severity-low" | "severity-neutral" | "" | undefined = "grey";
                                    let statusIcon = mdiHelpCircleOutline;


                                    if (item.status === 'OPEN.COMPLETE') {
                                        statusText = "Apertura";
                                        statusColor = 'green';
                                        statusIcon = mdiCheckCircleOutline
                                    } else if (item.status === 'OPEN.PENDING') {
                                        statusText = "Apertura";
                                        statusColor = 'severity-low';
                                        statusIcon = mdiTimerSandEmpty
                                    } else if (item.status === 'OPEN.BUSY') {
                                        statusText = "Apertura";
                                        statusColor = 'severity-high';
                                        statusIcon = mdiCloseCircleOutline
                                    } else if (item.status === 'MANUAL.OPEN') {
                                        statusText = "Manual";
                                        statusColor = "blue";
                                        statusIcon = mdiBoomGateArrowUpOutline;
                                    } else if (item.status === 'ACCESS.BLOCK') {
                                        statusText = "Acceso";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOutline
                                    } else if (item.status === 'ACCESS.UNBLOCK') {
                                        statusText = "Acceso";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOpenOutline
                                    } else if (item.status === 'UNIT.BLOCK') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOutline
                                    } else if (item.status === 'UNIT.UNBLOCK') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiLockOpenOutline
                                    } else if (item.status === 'POLICY.ADD') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiTimerPlusOutline
                                    } else if (item.status === 'POLICY.DELETE') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiDeleteClockOutline
                                    } else if (item.status === 'POLICY.MOD') {
                                        statusText = "Unidad";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiTimerEditOutline
                                    } else if (item.status === 'GUEST.ARRIVAL') {
                                        statusText = "Invitados";
                                        statusColor = "severity-neutral";
                                        statusIcon = mdiEmailOpenOutline
                                    } else {
                                        statusText = item.status; // Default to the item's status
                                        statusColor = 'grey'; // Or some other default color
                                    }

                                    return (
                                        <Box display="inline" key={`BX${item.idLog}`}>
                                            <Badge key={`BG${item.idLog}`} color={statusColor}>
                                                {statusIcon && <Icon key={`IC${item.idLog}`} path={statusIcon} size={0.5} />} {statusText}
                                            </Badge>
                                        </Box>
                                    );
                                },
                                width: 150,
                            },
                            {
                                id: "log",
                                header: "Registro",
                                cell: item => (
                                    <div>
                                        <div style={{ fontWeight: "bold" }}>{item.user !== '' ? item.user : "SISTEMA"}</div>
                                        <div style={{ color: "#666", fontSize: "12px" }}>{item.log}</div>
                                    </div>
                                ),
                            },
                        ]}
                        items={paginatedLogs}
                        //selectionType="multi"
                        empty={<Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                            <SpaceBetween size="m">
                                {date === '' ? (
                                    <b>No tiene bitácoras para el día seleccionado</b>
                                ) : (
                                    <b>Seleccione una fecha para consultar bitácora</b>
                                )}
                            </SpaceBetween>
                        </Box>}
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Filtrar por texto">
                                    <TextFilter
                                        filteringText={filteringText}
                                        onChange={({ detail }) => {
                                            setFilteringText(detail.filteringText);

                                            setCurrentPageIndex(1);
                                        }} />
                                </FormField>
                                <FormField label="Fecha de consulta" constraintText={
                                    <>
                                        <SpaceBetween direction='horizontal' size='xxs'>
                                            <Link onClick={handleYesterday}><Badge color='blue'>Ayer</Badge></Link>
                                            <Link onClick={handleToday}><Badge color='blue'>Hoy</Badge></Link>
                                        </SpaceBetween>
                                    </>
                                }>
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Input key={"inputDate"}
                                            value={selectedDate}
                                            readOnly
                                        />
                                        <Button
                                            key={"btnCalendar"}
                                            iconSvg={<Icon path={mdiCalendarOutline} size={0.7} />}
                                            onClick={() => setModalOpen(true)}
                                        />
                                        {selectedDate !== "" && (
                                            <Button
                                                key={"btnDate"}
                                                iconSvg={<Icon path={mdiRefresh} size={0.7} />}
                                                loading={loading}
                                                onClick={() => {
                                                    if (selectedDate !== "") {
                                                        setCurrentPageIndex(1);
                                                        handleRefresh();
                                                    }
                                                }}

                                            />
                                        )}
                                    </SpaceBetween>
                                </FormField>
                            </SpaceBetween>
                        }

                        pagination={
                            filteredLogs.length > pageSize && (
                                <Pagination
                                    currentPageIndex={currentPageIndex}
                                    pagesCount={Math.ceil(filteredLogs.length / pageSize)}
                                    onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)} />
                            )
                        }
                    />

                    <DatePickerModal
                        visible={modalOpen}
                        clear={false}
                        close={false}
                        today
                        end={new Date()}
                        start={subMonths(new Date(), 3)}
                        onDismiss={() => {
                            setModalOpen(false)
                            //console.log("DISMISS")
                        }}
                        onConfirm={(date) => {
                            setModalOpen(false);
                            setCurrentPageIndex(1);
                            setSelectedDate(date)
                        }}
                    />
                </SpaceBetween>
            }
        />

    );
};